








































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
@Component({ components: {} })
export default class ToolbarUser extends Vue {
  @Prop({ type: Array, default: [] })
  private items!: any[]

  @Prop()
  private user
  @Prop({ type: Boolean, default: false })
  private clearable

  private badge = this.items.length > 0 ? true : false

  goToUrl(url: string) {
    this.$router.push(`/${url}`)
  }
  @Watch('items')
  updateBadge() {
    this.badge = this.items.length > 0 ? true : false
  }
}
